import {Injectable} from '@angular/core';
import {GroupConfig} from '../../shared/models/config';

@Injectable({
  providedIn: 'root'
})
export class GetConfigOrderService {

  constructor() {}

  /*
  * ORDER ADD
  * */
  getConfigOrderSite(): GroupConfig {
    return {
      'config': [
        // {
        //   type: 'input',
        //   label: 'ORDER_FORM_SITE_NAME',
        //   controlName: ['name'],
        //   options: {
        //     show: true,
        //     duplicate: ['siteName'],
        //     labelShowInDetail: false
        //   },
        //   placeholder: 'ORDER_FORM_SITE_NAME',
        //   presentation: 'edit'
        // },
        {
          type: 'typeAhead',
          label: 'GENERIC_SITE',
          controlName: [ 'name', 'uuid'],
          placeholder: 'GENERIC_SITE',
          data: 'sites',
          options: {
            show: true,
            value: 'uuid',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
        {
          type: 'input',
          label: 'ORDER_FORM_SITE_EXTERNAL_ID',
          controlName: ['externalID'],
          placeholder: 'ORDER_FORM_SITE_EXTERNAL_ID',
          presentation: 'edit',
          options: {
            show: true,
            shortInput: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'typeAhead',
          label: 'ORDER_FORM_SITE_TIMEZONE',
          controlName: [ 'ianaCode' , 'timezoneName'],
          placeholder: 'ORDER_FORM_SITE_TIMEZONE',
          data: 'timeZone',
          options: {
            show: true,
            value: 'ianaCode',
            vue: 'ianaCode',
            labelShowInDetail: true,
            disableMessage: 'Please fill first the site address',
          },
          presentation: 'edit'
        },
      ]
    }
  }

  getConfigOrderSiteOthers(): GroupConfig {
    return {
      'config': [
        {
          type: 'select',
          label: 'ORDER_FORM_SITE_TIMEZONE',
          controlName: ['timeZone', 'ianaCode'],
          placeholder: 'ORDER_FORM_SITE_TIMEZONE',
          data: 'timeZone',
          options: {
            show: true,
            value: 'ianaCode',
            vue: 'ianaCode',
            labelShowInDetail: true,
          },
          presentation: 'edit'
        },
        // {
        //   type: 'multiselect',
        //   label: 'ORDER_FORM_SITE_CULTURES',
        //   controlName: ['cultures', 'code'],
        //   placeholder: 'ORDER_FORM_SITE_CULTURES',
        //   data: 'cultures',
        //   options: {
        //     show: true,
        //     value: 'code',
        //     vue: 'englishName',
        //     labelShowInDetail: true
        //   },
        //   presentation: 'edit'
        // },
      ]
    }
  }
  getConfigConcepts(): GroupConfig {
    return {
      'config': [
        {
          type: 'multiselect',
          label: 'ORDER_FORM_SITE_CONCEPTS',
          controlName: ['concepts', 'id'],
          placeholder: 'ORDER_FORM_SITE_CONCEPTS',
          data: 'concepts',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
      ]
    }
  }
  getConfigOrderProductionLine(): GroupConfig {
    return {
      'config': [
        {
          type: 'select',
          label: '',
          controlName: ['productionLine', 'code'],
          placeholder: '',
          data: 'productionLine',
          options: {
            show: true,
            value: 'code',
            vue: 'name',
            longInput: true,
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
      ]
    }
  }

  formConfigSubscriptionOthers(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: '',
          controlName: [ 'name'],
          options: {
            show: true,
            labelShowInDetail: false,
            inputExtraLabels : '',
            inputExtraLabelsTitle : 'ORDER_FORM_SITE_NAME',
          },
          placeholder: 'ORDER_FORM_SITE_NAME_SUFFIX',
          presentation: 'edit'
        },
        {
          type: 'multiselect',
          label: 'ORDER_FORM_SITE_CULTURES',
          controlName: ['cultures', 'code'],
          placeholder: 'ORDER_FORM_SITE_CULTURES',
          data: 'cultures',
          options: {
            show: true,
            value: 'code',
            vue: 'englishName',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
        {
          type: 'input',
          label: 'ORDER_FORM_STATUTORY_NAME',
          controlName: ['statutoryName'],
          placeholder: 'ORDER_FORM_STATUTORY_NAME',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
      ]
    }
  }
  getConfigOrderSubscription(): GroupConfig {
    return {
      'config': [
        {
          type: 'select',
          label: 'ORDER_FORM_SUBSCRIPTION_SERVICE',
          controlName: ['service', 'id'],
          placeholder: 'ORDER_FORM_SUBSCRIPTION_SERVICE',
          data: 'servicesList',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
        {
          type: 'select',
          label: 'ORDER_FORM_SUBSCRIPTION_PRODUCT',
          controlName: ['product', 'id'],
          placeholder: 'ORDER_FORM_SUBSCRIPTION_PRODUCT',
          data: 'product',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
        {
          type: 'select',
          label: 'ORDER_FORM_SUBSCRIPTION_STATUS',
          controlName: ['status', 'id'],
          placeholder: 'ORDER_FORM_SUBSCRIPTION_STATUS',
          data: 'status',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
        {
          type: 'select',
          label: 'ORDER_FORM_SUBSCRIPTION_SCREEN_ORIENTATION',
          controlName: ['screenRotation', 'id'],
          placeholder: 'ORDER_FORM_SUBSCRIPTION_SCREEN_ORIENTATION',
          data: 'screenRotation',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            toggle: false,
            labelShowInDetail: true,
            allowOptionEmpty: false
          },
          presentation: 'edit'
        }
      ]
    }
  }
  getConfigOrderSubscriptionBis(): GroupConfig {
    return {
      'config': [
        {
          type: 'select',
          label: 'ORDER_FORM_SUBSCRIPTION_SERVICE',
          controlName: ['service', 'id'],
          placeholder: 'ORDER_FORM_SUBSCRIPTION_SERVICE',
          data: 'servicesList',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
        {
          type: 'select',
          label: 'ORDER_FORM_SUBSCRIPTION_PRODUCT',
          controlName: ['product', 'id'],
          placeholder: 'ORDER_FORM_SUBSCRIPTION_PRODUCT',
          data: 'product',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
        {
          type: 'select',
          label: 'ORDER_FORM_SUBSCRIPTION_STATUS',
          controlName: ['status', 'id'],
          placeholder: 'ORDER_FORM_SUBSCRIPTION_STATUS',
          data: 'status',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
        {
          type: 'select',
          label: 'ORDER_FORM_SUBSCRIPTION_SCREEN_ORIENTATION',
          controlName: ['screenRotation', 'id'],
          placeholder: 'ORDER_FORM_SUBSCRIPTION_SCREEN_ORIENTATION',
          data: 'screenRotation',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            toggle: false,
            labelShowInDetail: true,
            allowOptionEmpty: false
          },
          presentation: 'edit'
        },
        {
          type: 'checkBox',
          label: 'IS_SOLD',
          controlName: ['isSold'],
          placeholder: 'IS_SOLD',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            labelPosition: 'left'
          }
        }
      ]
    }
  }

  getConfigServer(): GroupConfig {
    return {
      'config': [
        {
          type: 'select',
          label: 'ORDER_FORM_CMS',
          controlName: ['cms', 'id'],
          placeholder: 'ORDER_FORM_CMS',
          data: 'cms',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
        // {
        //   type: 'select',
        //   label: 'ORDER_FORM_SERVERS',
        //   controlName: ['server', 'id'],
        //   placeholder: 'ORDER_FORM_SERVERS',
        //   data: 'servers',
        //   options: {
        //     show: true,
        //     value: 'id',
        //     vue: 'name',
        //     labelShowInDetail: true
        //   },
        //   presentation: 'edit'
        // },
        {
          type: 'select',
          label: 'ORDER_FORM_URL',
          controlName: ['url' , 'id'],
          placeholder: 'ORDER_FORM_URL',
          presentation: 'edit',
          data: 'serversUrl',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
        },

      ]
    }
  }

  getConfigOrderMiscDatePicker(): GroupConfig {
    return {
      'config': [
        {
          type: 'datePicker',
          label: 'ORDER_FORM_SITE_EXPEDITION_DATE',
          controlName: ['expeditionDate'],
          placeholder: 'ORDER_FORM_SITE_EXPEDITION_DATE',
          error: 'ORDER_FORM_SITE_EXPEDITION_DATE_ERROR',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              numberDelayDays: 7, // 5 open days + 2 for week-end
              minDate: true,
              useCurrent: true,
              defaultDate: true,
              widgetPositioning: {
                horizontal: 'auto',
                vertical: 'bottom'
              }
            }
          },
          presentation: 'edit'
        },
        {
          type: 'checkBox',
          label: 'HAS_MATERIAL',
          controlName: ['hasMaterial'],
          placeholder: '',
          presentation: 'edit',
          options: {
            show: true,
            labelPosition: 'left'
          }
        },
        {
          type: 'checkBox',
          label: 'HAS_SETUP',
          controlName: ['hasSetup'],
          placeholder: '',
          presentation: 'edit',
          options: {
            show: true,
            labelPosition: 'left'
          }
        },
      ]
    }
  }

  getConfigOrderAddress(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'ORDER_FORM_ADDRESS_LINE_1',
          controlName: ['line1'],
          placeholder: 'ORDER_FORM_ADDRESS_LINE_1',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: false
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_ADDRESS_LINE_2',
          controlName: ['line2'],
          placeholder: 'ORDER_FORM_ADDRESS_LINE_2',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: false
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_ADDRESS_LINE_3',
          controlName: ['line3'],
          placeholder: 'ORDER_FORM_ADDRESS_LINE_3',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: false
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_ADDRESS_ZIP',
          controlName: ['zip'],
          placeholder: 'ORDER_FORM_ADDRESS_ZIP',
          presentation: 'edit',
          options: {
            show: false,
            shortInput: true,
            concatenate: ['zip', 'city'],
            labelShowInDetail: false
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_ADDRESS_CITY',
          controlName: ['city'],
          placeholder: 'ORDER_FORM_ADDRESS_CITY',
          presentation: 'edit',
          options: {
            show: false,
            labelShowInDetail: false
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_ADDRESS_STATE',
          controlName: ['state'],
          placeholder: 'ORDER_FORM_ADDRESS_STATE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: false
          }
        },
        {
          type: 'select',
          label: 'ORDER_FORM_ADDRESS_COUNTRY',
          controlName: ['countryForm', 'name'],
          placeholder: 'ORDER_FORM_ADDRESS_COUNTRY',
          data: 'country',
          options: {
            show: true,
            value: 'name',
            vue: 'name',
            labelShowInDetail: false
          },
          presentation: 'edit'
        },
      ]
    }
  }

  getConfigDeliveryAddress(): GroupConfig {
    return {
      'config': [
        {
          type: 'checkBox',
          label: 'SHIPPING_ADDRESS_SAME_AS',
          controlName: ['checkBox'],
          placeholder: '',
          presentation: 'edit',
          options: {
            show: true,
            labelPosition: 'right'
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_ADDRESS_LINE_1',
          controlName: ['line1'],
          placeholder: 'ORDER_FORM_ADDRESS_LINE_1',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: false
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_ADDRESS_LINE_2',
          controlName: ['line2'],
          placeholder: 'ORDER_FORM_ADDRESS_LINE_2',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: false
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_ADDRESS_LINE_3',
          controlName: ['line3'],
          placeholder: 'ORDER_FORM_ADDRESS_LINE_3',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: false
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_ADDRESS_ZIP',
          controlName: ['zip'],
          placeholder: 'ORDER_FORM_ADDRESS_ZIP',
          presentation: 'edit',
          options: {
            show: false,
            shortInput: true,
            concatenate: ['zip', 'city'],
            labelShowInDetail: false
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_ADDRESS_CITY',
          controlName: ['city'],
          placeholder: 'ORDER_FORM_ADDRESS_CITY',
          presentation: 'edit',
          options: {
            show: false,
            labelShowInDetail: false
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_ADDRESS_STATE',
          controlName: ['state'],
          placeholder: 'ORDER_FORM_ADDRESS_STATE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: false
          }
        },
        {
          type: 'select',
          label: 'ORDER_FORM_ADDRESS_COUNTRY',
          controlName: ['countryForm', 'name'],
          placeholder: 'ORDER_FORM_ADDRESS_COUNTRY',
          data: 'country',
          options: {
            show: true,
            value: 'name',
            vue: 'name',
            labelShowInDetail: false
          },
          presentation: 'edit'
        },
      ]
    }
  }

  getConfigOrderContact(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'ORDER_FORM_CONTACT_NAME',
          controlName: ['name'],
          placeholder: 'ORDER_FORM_CONTACT_NAME_PLACEHOLDER',
          presentation: 'edit',
          options: {
            show: false,
            concatenate: ['name', 'surname'],
            labelShowInDetail: false
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_CONTACT_SURNAME',
          controlName: ['surname'],
          placeholder: 'ORDER_FORM_CONTACT_SURNAME_PLACEHOLDER',
          presentation: 'edit',
          options: {
            show: false,
            labelShowInDetail: false
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_CONTACT_PHONE',
          controlName: ['phone'],
          placeholder: 'ORDER_FORM_CONTACT_PHONE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: false
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_CONTACT_MOBILE',
          controlName: ['mobile'],
          placeholder: 'ORDER_FORM_CONTACT_MOBILE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: false
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_CONTACT_EMAIL',
          controlName: ['email'],
          placeholder: 'ORDER_FORM_CONTACT_EMAIL',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: false
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_CONTACT_DEPARTMENT',
          controlName: ['department'],
          placeholder: 'ORDER_FORM_CONTACT_DEPARTMENT',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: false
          }
        },
      ]
    }
  }

  getConfigOrderSubNetworkIpAddress(): GroupConfig {
    return {
      'config': [
        {
          type: 'checkBox',
          label: 'ORDER_FORM_NETWORK_IP_ADDRESS_IS_DHCP',
          controlName: ['isDhcp'],
          placeholder: 'ORDER_FORM_NETWORK__IP_ADDRESS_IS_DHCP',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            labelPosition: 'left'
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_NETWORK_IP_ADDRESS_IP',
          controlName: ['ip'],
          placeholder: 'ORDER_FORM_NETWORK_IP_ADDRESS_IP',
          presentation: 'edit',
          options: {
            show: true,
            errorAllow: true,
            labelShowInDetail: true
          },
        },
        {
          type: 'input',
          label: 'ORDER_FORM_NETWORK_IP_ADDRESS_MASK',
          controlName: ['mask'],
          placeholder: 'ORDER_FORM_NETWORK_IP_ADDRESS_MASK',
          presentation: 'edit',
          options: {
            show: true,
            errorAllow: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_NETWORK_IP_ADDRESS_GATEWAY',
          controlName: ['gateway'],
          placeholder: 'ORDER_FORM_NETWORK_IP_ADDRESS_GATEWAY',
          presentation: 'edit',
          options: {
            show: true,
            errorAllow: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_NETWORK_IP_ADDRESS_DNS1',
          controlName: ['dns1'],
          placeholder: 'ORDER_FORM_NETWORK_IP_ADDRESS_DNS1',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_NETWORK_IP_ADDRESS_DNS2',
          controlName: ['dns2'],
          placeholder: 'ORDER_FORM_NETWORK_IP_ADDRESS_DNS2',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
      ]
    }
  }

  getConfigOrderSubNetworkWifi(): GroupConfig {
    return {
      'config': [
        {
          type: 'checkBox',
          label: 'ORDER_FORM_WIFI_ENABLE',
          controlName: ['enable'],
          placeholder: 'ORDER_FORM_WIFI_ENABLE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            labelPosition: 'left',
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_WIFI_SSID',
          controlName: ['ssid'],
          placeholder: 'ORDER_FORM_WIFI_SSID',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'select',
          label: 'ORDER_FORM_WIFI_security',
          controlName: ['security_type', 'code'],
          placeholder: 'ORDER_FORM_WIFI_security',
          presentation: 'edit',
          data: 'security_type',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true,
            allowOptionEmpty: false,
          },
        },
        {
          type: 'input',
          label: 'ORDER_FORM_WIFI_PASSWORD',
          controlName: ['security_password'],
          placeholder: 'ORDER_FORM_WIFI_PASSWORD',
          presentation: 'edit',
          options: {
            show: true,
            toggle: false,
            labelShowInDetail: true,
          }
        },
        {
          type: 'select',
          label: 'ORDER_FORM_WIFI_EAP_METHOD',
          controlName: ['eap_methodName', 'code'],
          placeholder: 'ORDER_FORM_WIFI_EAP_METHOD',
          presentation: 'edit',
          data: 'eap_methodName',
          options: {
            show: true,
            toggle: false,
            labelShowInDetail: true,
            value: 'id',
            vue: 'name',
            allowOptionEmpty: false,
          }
        },
        {
          type: 'select',
          label: 'ORDER_FORM_WIFI_EAP_PHASE_2_AUTH',
          controlName: ['eap_phase_2_authentication', 'code'],
          placeholder: 'ORDER_FORM_WIFI_EAP_PHASE_2_AUTH',
          data: 'eap_phase_2_authentication',
          presentation: 'edit',
          options: {
            show: true,
            toggle: false,
            labelShowInDetail: true,
            value: 'id',
            vue: 'name',
            allowOptionEmpty: false,
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_WIFI_EAP_CA_CERTIFICATE',
          controlName: ['eap_ca_certificate'],
          placeholder: 'ORDER_FORM_WIFI_EAP_CA_CERTIFICATE',
          presentation: 'edit',
          options: {
            show: true,
            toggle: false,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_WIFI_EAP_CA_USER',
          controlName: ['eap_user_certificate'],
          placeholder: 'ORDER_FORM_WIFI_EAP_CA_USER',
          presentation: 'edit',
          options: {
            show: true,
            toggle: false,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_WIFI_EAP_IDENTITY',
          controlName: ['eap_identity'],
          placeholder: 'ORDER_FORM_WIFI_EAP_IDENTITY',
          presentation: 'edit',
          options: {
            toggle: false,
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_WIFI_EAP_ANONYMOUS_IDENTITY',
          controlName: ['eap_anonymous_identity'],
          placeholder: 'ORDER_FORM_WIFI_EAP_ANONYMOUS_IDENTITY',
          presentation: 'edit',
          options: {
            show: true,
            toggle: false,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_WIFI_PASSWORD',
          controlName: ['eap_password'],
          placeholder: 'ORDER_FORM_WIFI_PASSWORD',
          presentation: 'edit',
          options: {
            show: true,
            toggle: false,
            labelShowInDetail: true
          }
        },
      ]
    }
  }

  getConfigOrderSubNetworkProxy(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'ORDER_FORM_NETWORK_PROXY_ADDRESS',
          controlName: ['addressProxy'],
          placeholder: 'ORDER_FORM_NETWORK_PROXY_ADDRESS',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_NETWORK_PROXY_PORT',
          controlName: ['port'],
          placeholder: 'ORDER_FORM_NETWORK_PROXY_PORT',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
      ]
    }
  }

  getConfigOrderMisc(): GroupConfig {
    return {
      'config': [
        {
          type: 'textarea',
          label: '',
          controlName: ['commentsBlog'],
          placeholder: 'GENERIC_COMMENT',
          presentation: 'detail',
          options: {
            show: true,
            labelShowInDetail: false
          }
        },
        {
          type: 'textarea',
          label: '',
          controlName: ['comments'],
          placeholder: 'GENERIC_COMMENT',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: false
          }
        }
      ]
    }
  }

  getConfigOrderMiscCreated(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_CREATED_LABEL',
          controlName: ['createdBy'],
          placeholder: 'GENERIC_CREATED_LABEL',
          presentation: 'detail',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_UPDATED_LABEL',
          controlName: ['updatedBy'],
          placeholder: 'GENERIC_UPDATED_LABEL',
          presentation: 'detail',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
      ]
    }
  }

  getConfigOrderMiscPlayer(): GroupConfig {
    return {
      'config': [
        {
          type: 'link',
          label: 'GENERIC_PLAYER_NAME',
          controlName: ['displayName'],
          placeholder: 'GENERIC_PLAYER_NAME',
          presentation: 'detail',
          linkHref: {
            url: null,
            target: '_blank',
            linkName: 'displayName'
          }
        },
        {
          type: 'input',
          label: 'GENERIC_MAC_ADDRESS',
          controlName: ['deviceMacAddress'],
          placeholder: 'GENERIC_MAC_ADDRESS',
          presentation: 'detail',
          options: {
            show: true,
            labelShowInDetail: true
          }
        }
      ]
    }
  }

  getConfigOrderFilter(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_ORDER_ID',
          controlName: ['id'],
          placeholder: 'GENERIC_ORDER_ID',
          presentation: 'filter',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_CLIENTS_NAME',
          controlName: ['clientName'],
          placeholder: 'GENERIC_CLIENTS',
          presentation: 'filter',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_SITE',
          controlName: ['siteName'],
          placeholder: 'GENERIC_SITE',
          presentation: 'filter',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_PLAYER_NAME',
          controlName: ['playerName'],
          placeholder: 'GENERIC_PLAYER_NAME',
          presentation: 'filter',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'select',
          label: 'GENERIC_SERVICES_LABEL',
          controlName: ['serviceID', 'id'],
          placeholder: 'GENERIC_SERVICES_LABEL',
          data: 'servicesList',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'filter'
        },
        {
          type: 'select',
          label: 'ORDER_FORM_SUBSCRIPTION_PRODUCT',
          controlName: ['productID', 'id'],
          placeholder: 'ORDER_FORM_SUBSCRIPTION_PRODUCT',
          data: 'product',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'filter'
        },
        {
          type: 'select',
          label: 'GENERIC_COUNTRY',
          controlName: ['countryCode', 'code'],
          placeholder: 'GENERIC_COUNTRY',
          data: 'country',
          options: {
            show: true,
            value: 'code',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'filter'
        },
        {
          type: 'dateRangePicker',
          label: 'ORDERS_LIST_FILTER_DELIVERY_DATE',
          controlName: ['deliveryDateStart' , 'deliveryDateStop'],
          placeholder: 'ORDERS_LIST_FILTER_DELIVERY_DATE',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null,
              daysOfWeekDisable: false,
              widgetPositioning: {
                horizontal: 'auto',
                vertical: 'bottom'
              }
            }
          },
          presentation: 'filter'
        },
        {
          type: 'dateRangePicker',
          label: 'ORDERS_LIST_FILTER_PICKUP_DATE',
          controlName: ['pickupDateStart' , 'pickupDateStop'],
          placeholder: 'ORDERS_LIST_FILTER_PICKUP_DATE',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null,
              daysOfWeekDisable: false,
              widgetPositioning: {
                horizontal: 'auto',
                vertical: 'bottom'
              }
            }
          },
          presentation: 'filter'
        },

        {
          type: 'select',
          label: 'GENERIC_LIST_STATUS',
          controlName: ['status', 'id'],
          placeholder: 'GENERIC_LIST_STATUS',
          data: 'orderstatus',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'filter'
        },
        {
          type: 'select',
          label: 'ORDER_LIST_TYPE',
          controlName: ['type', 'id'],
          placeholder: 'ORDER_LIST_TYPE',
          data: 'typeOrder',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'filter'
        },
        {
          type: 'dateRangePicker',
          label: 'ORDERS_LIST_FILTER_DISPATCH_DATE',
          controlName: ['expeditionDateStart' , 'expeditionDateStop'],
          placeholder: 'ORDERS_LIST_FILTER_DISPATCH_DATE',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null,
              daysOfWeekDisable: false,
              widgetPositioning: {
                horizontal: 'auto',
                vertical: 'bottom'
              }
            }
          },
          presentation: 'filter'
        },
      ]
    }
  }

  getConfigShippingAddressForm(): GroupConfig {
    return {
      'config': [
        {
          type: 'select',
          label: 'ORDER_LIST_CREATE_SHIPMENT_TRANSPORTER',
          controlName: ['transporter', 'id'],
          placeholder: 'ORDER_LIST_CREATE_SHIPMENT_TRANSPORTER',
          data: 'transporter',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
        {
          type: 'select',
          label: 'ORDER_LIST_CREATE_SHIPMENT_SELECTADDRESS',
          controlName: ['addresstype', 'id'],
          placeholder: 'ORDER_LIST_CREATE_SHIPMENT_SELECTADDRESS',
          data: 'addresstype',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
        {
          type: 'input',
          label: 'ORDER_LIST_CREATE_SHIPMENT_COMPANY',
          controlName: ['Company'],
          placeholder: 'ORDER_LIST_CREATE_SHIPMENT_COMPANY',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_LIST_CREATE_SHIPMENT_NAME',
          controlName: ['Name'],
          placeholder: 'ORDER_LIST_CREATE_SHIPMENT_NAME',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_LIST_CREATE_SHIPMENT_FIRSTNAME',
          controlName: ['Firstname'],
          placeholder: 'ORDER_LIST_CREATE_SHIPMENT_FIRSTNAME',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_LIST_CREATE_SHIPMENT_EMAIL',
          controlName: ['Email'],
          placeholder: 'ORDER_LIST_CREATE_SHIPMENT_EMAIL',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_LIST_CREATE_SHIPMENT_PHONE',
          controlName: ['Tel'],
          placeholder: 'ORDER_LIST_CREATE_SHIPMENT_PHONE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_LIST_CREATE_SHIPMENT_ADDRESS',
          controlName: ['Address'],
          placeholder: 'ORDER_LIST_CREATE_SHIPMENT_ADDRESS',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_LIST_CREATE_SHIPMENT_POSTALCODE',
          controlName: ['Postalcode'],
          placeholder: 'ORDER_LIST_CREATE_SHIPMENT_POSTALCODE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_LIST_CREATE_SHIPMENT_CITY',
          controlName: ['CityName'],
          placeholder: 'ORDER_LIST_CREATE_SHIPMENT_CITY',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'select',
          label: 'GENERIC_COUNTRY',
          controlName: ['country', 'code'],
          placeholder: 'GENERIC_COUNTRY',
          data: 'country',
          options: {
            show: true,
            value: 'code',
            vue: 'name'
          },
          presentation: 'edit',
        }
      ],
    }
  }

  getConfigShippingPackageForm(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'ORDER_LIST_CREATE_SHIPMENT_DESCRIPTION',
          controlName: ['Description'],
          placeholder: 'ORDER_LIST_CREATE_SHIPMENT_DESCRIPTION',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_LIST_CREATE_SHIPMENT_REFERENCE',
          controlName: ['Reference'],
          placeholder: 'ORDER_LIST_CREATE_SHIPMENT_REFERENCE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'select',
          label: 'ORDER_LIST_CREATE_SHIPMENT_IDENTIFIER',
          controlName: ['boxtype', 'id'],
          placeholder: 'ORDER_LIST_CREATE_SHIPMENT_IDENTIFIER',
          data: 'boxtype',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
        {
          type: 'input',
          label: 'ORDER_LIST_CREATE_SHIPMENT_WEIGHT',
          controlName: ['Weight'],
          placeholder: 'ORDER_LIST_CREATE_SHIPMENT_WEIGHT',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_LIST_CREATE_SHIPMENT_HEIGHT',
          controlName: ['Height'],
          placeholder: 'ORDER_LIST_CREATE_SHIPMENT_HEIGHT',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_LIST_CREATE_SHIPMENT_WIDTH',
          controlName: ['Width'],
          placeholder: 'ORDER_LIST_CREATE_SHIPMENT_WIDTH',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_LIST_CREATE_SHIPMENT_LENGTH',
          controlName: ['Length'],
          placeholder: 'ORDER_LIST_CREATE_SHIPMENT_LENGTH',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'datePicker',
          label: 'ORDER_LIST_CREATE_SHIPMENT_DATE',
          controlName: ['ShippingDateTime'],
          placeholder: 'ORDER_LIST_CREATE_SHIPMENT_DATE',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              numberDelayDays: 0,
              minDate: true,
              useCurrent: true,
              defaultDate: true
            }
          },
          presentation: 'edit'
        },
        {
          type: 'select',
          label: 'ORDER_LIST_RATING_SELECT',
          controlName: ['Product', 'productCode'],
          placeholder: 'ORDER_LIST_RATING_SELECT',
          data: 'productCodeDHL',
          options: {
            show: true,
            value: 'productCode',
            vue: 'productName' ,
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
      ],
    }
  }


  getConfigReturnForm(): GroupConfig {
    return {
      'config': [
        {
          type: 'select',
          label: 'ORDER_LIST_CREATE_SHIPMENT_REFERENCE',
          controlName: ['ReferenceReturn', 'name'],
          placeholder: 'ORDER_LIST_CREATE_SHIPMENT_REFERENCE',
          data: 'allplayerids',
          options: {
            show: true,
            value: 'name',
            vue: 'name' ,
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
      ],
    }
  }

  getConfigValidationTicket(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'ORDER_FORM_VALIDATION_TICKET_TITLE',
          controlName: ['titleTicket'],
          placeholder: 'ORDER_FORM_VALIDATION_TICKET_TITLE',
          presentation: 'detail',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_VALIDATION_TICKET_TITLE_TODO',
          controlName: ['titleTodo'],
          placeholder: 'ORDER_FORM_VALIDATION_TICKET_TITLE_TODO',
          presentation: 'detail',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'select',
          label: 'ORDER_FORM_VALIDATION_TICKET_ASSIGNED_TO',
          controlName: ['assignedTo', 'id'],
          placeholder: 'ORDER_FORM_VALIDATION_TICKET_ASSIGNED_TO',
          data: 'support',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
        {
          type: 'textarea',
          label: 'ORDER_FORM_VALIDATION_TICKET_DESCRIPTION',
          controlName: ['description'],
          placeholder: 'ORDER_FORM_VALIDATION_TICKET_DESCRIPTION',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'datePicker',
          label: 'ORDER_FORM_VALIDATION_TICKET_DUE_DATE',
          controlName: ['dueDate'],
          placeholder: 'ORDER_FORM_VALIDATION_TICKET_DUE_DATE',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              numberDelayDays: 1,
              minDate: true,
              useCurrent: true,
              defaultDate: true
            }
          },
          presentation: 'edit'
        }
      ],
    }
  }

  getConfigPickUp(): GroupConfig {
    return {
      'config': [
        {
          type: 'select',
          label: 'ORDER_PICK_UP_TRANSPORTER',
          controlName: ['transporterID', 'id'],
          placeholder: 'ORDER_PICK_UP_TRANSPORTER',
          data: 'transporters',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
        {
          type: 'input',
          label: 'ORDER_PICK_UP_DHL_TRACKING_ID',
          controlName: ['trackingID'],
          placeholder: 'ORDER_PICK_UP_DHL_TRACKING_ID',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_PICK_UP_DHL_SHIP_FROM_TRACKING_ID',
          controlName: ['shipFromTrackingID'],
          placeholder: 'ORDER_PICK_UP_DHL_SHIP_FROM_TRACKING_ID',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            hideAll: 'show'
          }
        },
        {
          type: 'datePicker',
          label: 'ORDER_PICK_UP_DHL_DEPARTURE_DATE',
          controlName: ['departureDate'],
          placeholder: 'ORDER_PICK_UP_DHL_DEPARTURE_DATE',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: true,
              defaultDate: null
            }
          },
          presentation: 'edit'
        }
      ]
    }
  }

  getConfigAddPlayer(): GroupConfig {
    return {
      'config': [
        {
          type: 'typeAhead',
          label: 'GENERIC_PLAYERS',
          controlName: ['name', 'id'],
          placeholder: 'GENERIC_PLAYERS',
          data: 'device',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        }
      ]
    }
  }
  getConfigConceptsPlayer(): GroupConfig {
    return {
      'config': [
        {
          type: 'multiselect',
          label: 'ORDER_FORM_SITE_CONCEPTS',
          controlName: ['concepts', 'id'],
          placeholder: 'ORDER_FORM_SITE_CONCEPTS',
          data: 'concepts',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
      ]
    }
  }
  getConfigAddPlayerFamiliesWithBritgh(): GroupConfig {
    return {
      'config': [
        {
          type: 'select',
          label: 'GENERIC_FAMILIES',
          controlName: ['familiesName', 'name'],
          placeholder: 'GENERIC_FAMILIES',
          data: 'families',
          options: {
            show: true,
            value: 'name',
            vue: 'name',
            labelShowInDetail: true,
            inputOptions: false,
            allowOptionEmpty: false,
          },
          presentation: 'detail'
        },
        {
          type: 'input',
          label: 'GENERIC_ADOPTION_CODE',
          controlName: ['code'],
          placeholder: 'GENERIC_ADOPTION_CODE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            hideAll: 'show'
          }
        },
        {
          type: 'multiselect',
          label: 'ORDER_FORM_SITE_CONCEPTS',
          controlName: ['concepts', 'id'],
          placeholder: 'ORDER_FORM_SITE_CONCEPTS',
          data: 'concepts',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
        {
          type: 'select',
          label: 'Product model',
          controlName: ['bsnProductModel', 'name'],
          placeholder: 'Product model',
          data: 'bnsProductList',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true,
            inputOptions: false,
            allowOptionEmpty: false,
          },
          presentation: 'edit'
        },
        // {
        //   type: 'input',
        //   label: 'GENERIC_SERIAL_NUMBER',
        //   controlName: ['serialNumber'],
        //   placeholder: 'GENERIC_SERIAL_NUMBER',
        //   presentation: 'edit',
        //   options: {
        //     show: true,
        //     labelShowInDetail: true,
        //     hideAll: 'show'
        //   }
        // },
      ]
    }
  }
  getConfigAddPlayerFamilies(): GroupConfig {
    return {
      'config': [
        {
          type: 'select',
          label: 'GENERIC_FAMILIES',
          controlName: ['familiesName', 'name'],
          placeholder: 'GENERIC_FAMILIES',
          data: 'families',
          options: {
            show: true,
            value: 'name',
            vue: 'name',
            labelShowInDetail: true,
            inputOptions: false,
            allowOptionEmpty: false,
          },
          presentation: 'detail'
        },
        {
          type: 'input',
          label: 'GENERIC_ADOPTION_CODE',
          controlName: ['code'],
          placeholder: 'GENERIC_ADOPTION_CODE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            hideAll: 'show'
          }
        },
        {
          type: 'multiselect',
          label: 'ORDER_FORM_SITE_CONCEPTS',
          controlName: ['concepts', 'id'],
          placeholder: 'ORDER_FORM_SITE_CONCEPTS',
          data: 'concepts',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
        // {
        //   type: 'input',
        //   label: 'GENERIC_SERIAL_NUMBER',
        //   controlName: ['serialNumber'],
        //   placeholder: 'GENERIC_SERIAL_NUMBER',
        //   presentation: 'edit',
        //   options: {
        //     show: true,
        //     labelShowInDetail: true,
        //     hideAll: 'show'
        //   }
        // },
      ]
    }
  }


  getConfigCloseOrder(): GroupConfig {
    return {
      'config': [
        {
          type: 'datePicker',
          label: 'ORDER_TRACKING_DEPARTURE_DATE',
          controlName: ['departureDate'],
          placeholder: 'ORDER_TRACKING_DEPARTURE_DATE',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: true,
              defaultDate: null
            }
          },
          presentation: 'edit'
        }
      ]
    }
  }
}
